import { Activity, Coins, Gauge, ShieldCheck, Sparkles, type LucideIcon } from 'lucide-react';

/**
 * Icons for the main analytics surfaces, shared by the sidebar nav and the
 * workspace digest so a category always reads with the same icon
 * wherever it appears.
 */
export const SURFACE_NAV_ICONS = {
    'ai-explorer': Sparkles,
    behavior: Activity,
    adoption: Gauge,
    governance: ShieldCheck,
    'token-usage': Coins,
} satisfies Record<string, LucideIcon>;

/** The nav icon for a surface id (looked up dynamically), or undefined for an unknown surface. */
export function surfaceNavIcon(surfaceId: string): LucideIcon | undefined {
    return (SURFACE_NAV_ICONS as Record<string, LucideIcon>)[surfaceId];
}
